export const getLanguageBasedImage = (imageName) => {
    const language = localStorage.getItem('language') || 'tr';
    try {
        // First try to load language-specific image
        return require(`../images/${language}/${imageName}`);
    } catch {
        try {
            // If not found, try to load from root images folder
            return require(`../images/${imageName}`);
        } catch {
            console.error(`Image not found: ${imageName}`);
            return null;
        }
    }
};
